import React from 'react';
import classes from './ReferralInviteCard.module.scss';
import Copyable from '../../atoms/Copyable/Copyable';
import Card from '../../atoms/Card/Card';
import Txt from '../../atoms/Txt/Txt';
import Image from 'components/atoms/Image/Image';
interface Invite {
  inviteType: string;
  title: string;
  titleValue?: (currencySymbol: string) => string;
  description: string;
  descriptionValue?: (currencySymbol: string) => string;
  image: React.ElementType;
}

export interface Props {
  token: string;
  invite: Invite;
  currencySymbol: string;
}

const ReferralInviteCard: React.FC<Props> = ({ token, invite, currencySymbol }) => {
  const OinqImage = invite.image;
  return (
    <Card component="li" className={classes.card}>
      <div className={classes.content}>
        <Txt
          component="h2"
          translateOptions={{
            vars: invite.titleValue ? [invite.titleValue(currencySymbol)] || '' : [],
          }}
        >
          {invite.title}
        </Txt>
        <OinqImage className={classes.image} />
        <Txt
          component="p"
          className={classes.inviteDescription}
          translateOptions={{
            vars: invite.descriptionValue ? [invite.descriptionValue(currencySymbol)] || '' : [],
          }}
        >
          {invite.description}
        </Txt>
      </div>
      <Copyable value={`https://qm.ee/${token}`} />
    </Card>
  );
};

export default ReferralInviteCard;
